import { type BreakpointsOptions } from '@mui/material/styles';

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 1050,
    lg: 1280,
    xl: 1920,
  },
};

export default breakpoints;
